import React, { memo, useEffect, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import AppWebReportTaetigkeitsberichtReportEmployeeTable from "./AppWebReportTaetigkeitsberichtReportEmployeeTable";
import AppWebReportTaetigkeitsberichtAuftraggeber from "./AppWebReportTaetigkeitsberichtAuftraggeber";
import AppWebReportTaetigkeitsberichtWetter from "./AppWebReportTaetigkeitsberichtWetter";
import AppWebReportTaetigkeitsberichtGeraete from "./AppWebReportTaetigkeitsberichtGeraete";
import AppWebReportTaetigkeitsberichtMaterial from "./AppWebReportTaetigkeitsberichtMaterial";
//import AppWebReportTaetigkeitsberichtSignature from "./AppWebReportTaetigkeitsberichtSignature";
import AppWebReportTaetigkeitsberichtTagesTaetigkeitVerortung
    from "./AppWebReportTaetigkeitsberichtTagesTaetigkeitVerortung";
import AppWebReportTaetigkeitsberichtActionButtonsComponent
    from "./AppWebReportTaetigkeitsberichtActionButtonsComponent";

function AppWebReportTaetigkeitsberichtPage( props ) {
    const [taetigkeitsberichtData, setTaetigkeitsberichtData] = useState({});

    useEffect(() => {
        async function getTData() {
            let data = JSON.parse(JSON.stringify(props.reportData))
            setTaetigkeitsberichtData(data);
        }
        getTData().then((r) => r);
    }, []);

    useEffect(() => {}, [taetigkeitsberichtData]);


    return (
        <div className="handwai-dark">
            <div
                style={{
                    width: '100%'

                }}
            >
                <Row className="handwai-text-label-normal">
                    <Col />
                    <Col />
                    <Col />
                    <Col>
                        <br />

                        <div
                            style={{
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                height: '100%'
                            }}
                        >

                            &nbsp;

                        </div>
                    </Col>
                </Row>
                {/*{taetigkeitsberichtMetaData.id !== undefined && (
                    <AppWebReportTaetigkeitsberichtHeadings taetigkeitsberichtMetaData={taetigkeitsberichtMetaData} />
                )}*/}
                <br />
                <br />

                <Row>
                    <Col />
                    <Col sm={5}>
                        {taetigkeitsberichtData?.coworkers !== undefined && (
                            <AppWebReportTaetigkeitsberichtReportEmployeeTable
                                employeeData={taetigkeitsberichtData.coworkers}
                                />
                        )}
                    </Col>
                    <Col />
                    <Col sm={3}>
                        <AppWebReportTaetigkeitsberichtAuftraggeber
                            auftraggeberData={taetigkeitsberichtData?.auftraggeber}
                        />
                    </Col>
                    <Col />
                    <Col sm={2}>
                        <AppWebReportTaetigkeitsberichtWetter
                            wetterData={taetigkeitsberichtData?.wetter}
                        />
                    </Col>
                    <Col />
                </Row>
                <br />
                <Row>
                    <Col />
                    <Col sm={4}>
                        <label className="handwai-text-label-main">{'Tätigkeit'}</label>
                    </Col>
                    <Col sm={7}></Col>
                    <Col />
                </Row>
                <br />

                <AppWebReportTaetigkeitsberichtTagesTaetigkeitVerortung
                    taetigkeitsberichtData={taetigkeitsberichtData}
                />
                <br /> <br />
                <br /> <br />
                <Row>
                    <Col />
                    <Col sm={7}>
                        <AppWebReportTaetigkeitsberichtMaterial
                            materialData={taetigkeitsberichtData?.material}
                        />
                    </Col>
                    <Col sm={4}>
                        <AppWebReportTaetigkeitsberichtGeraete
                            geraeteData={taetigkeitsberichtData?.device}
                        />
                    </Col>
                    <Col />
                </Row>
                <br /> <br />
                <Row>
                    <Col />
                    {/*<Col sm={7}>

                            <AppWebReportTaetigkeitsberichtSignature
                                type={'creatorSign'}
                                name={
                                    "TestVN" +
                                    ' ' +
                                    "TestNN"
                                }
                                image={taetigkeitsberichtData?.creatorSignature}
                            />
                    </Col>*/}

                    <Col sm={4}></Col>
                    <Col />
                </Row>
            </div>

            <br />

            <div className="horizontal-line"></div>

            <div
                style={{
                    width: '100%'
                }}
            >
                <AppWebReportTaetigkeitsberichtActionButtonsComponent
                    taetigkeitsberichtData={taetigkeitsberichtData}
                />
            </div>

            <br />
        </div>
    );
}

export default memo(AppWebReportTaetigkeitsberichtPage);
